const getters = {
  getList: state => state.all,
  getPaginationCheck: state => state.disablePagination,
  getPage: state => state.page,
  getFilter: state => state.filter,
  getReturnReasonOptions: state => ((state.requestDetails)
    ? state.requestDetails.returnReasonOptions : []),
  getRequestInfo: state => ((state.requestDetails && state.requestDetails.requestDetails)
    ? state.requestDetails.requestDetails : {}),
  getAutopulateInfo: state => ((state.requestDetails && state.requestDetails.detailsToAutoPopulate)
    ? state.requestDetails.detailsToAutoPopulate : null),
};
export default getters;
